import Anchor from 'components/Content/Anchor/Anchor';

export default Anchor;
